import {
  Rule_Combinator,
  Rule_Condition_Operator,
} from "@safetyculture/s12-apis-connect-web/s12/rules/v1/common_pb";

export const combinatorStringToEnum = (combinator: string): Rule_Combinator => {
  switch (combinator) {
    case "and":
      return Rule_Combinator.AND;
    case "or":
      return Rule_Combinator.OR;
    default:
      return Rule_Combinator.UNSPECIFIED; // Default
  }
};

export const operatorStringToEnum = (
  operator: string,
): Rule_Condition_Operator => {
  switch (operator) {
    case "is":
      return Rule_Condition_Operator.IS;
    case "is_not":
      return Rule_Condition_Operator.IS_NOT;
    case "contains":
      return Rule_Condition_Operator.CONTAINS;
    case "contains_not":
      return Rule_Condition_Operator.CONTAINS_NOT;
    case "is_after":
      return Rule_Condition_Operator.IS_AFTER;
    case "is_before":
      return Rule_Condition_Operator.IS_BEFORE;
    default:
      return Rule_Condition_Operator.UNSPECIFIED;
  }
};
